<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <ng-container *ngIf="getContragentsWithClients?.length && isCommonClient">
          <p-messages severity="info">
            <ng-template pTemplate="">
              <div class="flex gap-2 align-items-center">
                <i
                  class="pi pi-exclamation-circle"
                  style="font-size: 1.3rem"></i>
                <p *ngIf="getContragentsWithClients?.length === 1; else manyContragents">
                  Выбранный Контрагент "{{ getContragentsWithClients | join: 'name' }}" уже имеет Клиента "{{
                    getContragentsWithClients | join: 'client.name'
                  }}". Его реквизиты при объединении контрагентов будут перенесены в нового Клиента.
                </p>
                <ng-template #manyContragents>
                  <p>
                    Выбранные Контрагенты: "{{ getContragentsWithClients | join: 'name' }}" уже имеют Клиентов: "{{
                      getContragentsWithClients | join: 'client.name'
                    }}". Реквизиты клиентов при объединении контрагентов будут перенесены в нового Клиента.
                  </p>
                </ng-template>
              </div>
            </ng-template>
          </p-messages>
        </ng-container>

        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="client.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>

        <div
          *ngIf="!isCommonClient"
          class="field">
          <label class="font-medium">Контрагенты</label>
          <crm-contragent-multi-select
            [(selectedEntities)]="client.contragents"
            [isError]="$any(errors?.contragents)"
            appendTo="body"></crm-contragent-multi-select>
          <small
            *ngIf="errors?.contragents"
            class="p-error">
            {{ errors.contragents | join }}
          </small>
        </div>

        <div
          *ngIf="isHelpdeskAvailable"
          class="field">
          <label class="font-medium">Типы заявок HelpDesk</label>
          <crm-hd-task-type-multi-select
            [customRequest]="true"
            [isFloatLabel]="false"
            [taskTypes]="helpdeskTaskTypes"
            [(selectedTaskTypes)]="client.helpdeskTaskTypes"
            [styleClass]="errors?.helpdeskTaskTypes ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.helpdeskTaskTypes ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-hd-task-type-multi-select>
          <small
            *ngIf="errors?.helpdeskTaskTypes"
            class="p-error">
            {{ errors?.helpdeskTaskTypes | join }}
          </small>
        </div>

        <div
          *ngIf="isPassageModuleEnabled"
          class="field">
          <label class="font-medium">Лимит постоянных ТС, кол-во</label>
          <p-inputNumber
            [(ngModel)]="client.residentCarLimit"
            [min]="0"
            class="w-full {{ errors?.residentCarLimit ? 'ng-invalid ng-dirty' : '' }}"
            styleClass="w-full {{ errors?.residentCarLimit ? 'ng-invalid ng-dirty' : '' }}"></p-inputNumber>
          <small
            *ngIf="errors?.residentCarLimit"
            class="p-error">
            {{ errors?.residentCarLimit | join }}
          </small>
        </div>

        @if (isPassageModuleEnabled) {
          <div class="field-checkbox mb-3">
            <p-checkbox
              [(ngModel)]="client.isCreateTransitTask"
              [binary]="true"
              inputId="clientFormIsCreateTransitTask"></p-checkbox>
            <label
              for="clientFormIsCreateTransitTask"
              class="font-medium">Создание гостевой заявки из события</label>
          </div>
        }

        <div class="field">
          <label class="font-medium">Филиалы</label>
          <crm-filial-multi-select
            [(selectedFilials)]="client.filials"
            [isFloatLabel]="false"
            styleClass="w-full {{ errors?.residentCarLimit ? 'ng-invalid ng-dirty' : '' }}"
            class="w-full {{ errors?.residentCarLimit ? 'ng-invalid ng-dirty' : '' }}"
            appendTo="body"></crm-filial-multi-select>
          <small
            *ngIf="errors?.filials"
            class="p-error">
            {{ errors?.filials | join }}
          </small>
        </div>
      </p-card>
    </div>

    @if (isPassageModuleEnabled) {
      <div class="col-12">
        <p-card styleClass="very-compact-card p-3">
          <h3 class="mb-3">Лимиты гостевых ТС по категориям</h3>
          <crm-transit-task-car-category-limits-form
            [(values)]="client.transitTaskCarCategoryLimits">
          </crm-transit-task-car-category-limits-form>
        </p-card>
      </div>
    }
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveClient()"></crm-button>
      <ng-container *ngIf="(form$ | async)?.isEdit">
        <crm-button
          *ngIf="!client['deleted'] && globalService.isAccessRule('BASIS:CLIENT:CAN_DELETE_CLIENTS')"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteClient()"></crm-button>

        <crm-button
          *ngIf="client['deleted']"
          label="Восстановить"
          styleClass="p-button-text"
          (onClick)="unlockClient()"></crm-button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
